import { render, staticRenderFns } from "./PingkaDataLight.vue?vue&type=template&id=8f5fd8b8&scoped=true"
import script from "./PingkaDataLight.vue?vue&type=script&lang=js"
export * from "./PingkaDataLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f5fd8b8",
  null
  
)

export default component.exports